import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-regates',
  templateUrl: './skeleton-regates.component.html',
  styleUrls: ['./skeleton-regates.component.scss']
})
export class SkeletonRegatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
